import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Select2 controller connected to", this.element);
    if (window.$ && window.$.fn.select2) {
      setTimeout(() => {
        try {
          this.select2 = window.$(this.element).select2({
            dropdownParent: window.$(this.element).parent(),
            placeholder: this.element.dataset.placeholder || t('employees.placeholder.select_employee'),
            allowClear: false
          })
          console.log("Select2 initialized successfully");
        } catch (e) {
          console.error("Select2 initialization failed:", e);
        }
      }, 50)
    } else {
      console.error("Select2 or jQuery not available in window scope.");
    }
  }

  disconnect() {
    if (this.select2 && window.$ && window.$.fn.select2) {
      try {
        window.$(this.element).select2('destroy')
      } catch (e) {
        console.error("Select2 destroy failed:", e);
      }
    }
  }
}
